import React from "react";
import Console from "../../library/console";
export default class Demo extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    Console.write('demo component');
    var msg = this.props.msg;

    if (!msg) {
      msg = 'Demo Component';
    }

    return /*#__PURE__*/React.createElement("div", null, msg);
  }

}